import {
  actions as authActions,
  operations as authOperations,
  utils as authUtils,
} from '@saucelabs/sl-container-authentication';
import { actions as permissionsActions } from '@saucelabs/sl-container-permissions';
import { actions as userConcurrencyActions } from '@saucelabs/sl-module-concurrency';
import { actions as userTunnelsActions } from '@saucelabs/sl-module-tunnels';
import { actions as messagesActions } from '@saucelabs/sl-module-messages';
import Sentry from '@saucelabs/sl-util-sentry';
import { CURRENT_DC } from '@saucelabs/sl-util-config';
import { cookiesHelper } from '@saucelabs/sl-util-helpers';

import * as actions from './actions';
import * as constants from './constants';

export const updateLastUsedDataCenter = (payload) => (dispatch) => {
  if (payload?.dcName) {
    // used by ForgeRock AM to find out to which DC user should be redirected
    cookiesHelper.setItem(constants.LAST_USED_DC, payload.dcName);
  }
  dispatch(actions.updateLastUsedDC(payload));
};

/*
Tries to fetch current user credentials while displaying loading state
in the whole UI, might be extended with other initial data requests
required for application to start.
*/
export const initialize = () => (dispatch, getState) => (
  // refresh JWT and gives sl-auth cookie
  dispatch(authActions.authenticateAM({}, { skipErrorPage: true }))
    .then(() => dispatch(authOperations.startCheckTimeToLogout()))
    .finally(() => (
      // RDC is not behind api gateway, so it doesnt respect sl-auth cookie
      // also, needed for headless as long as east-1 is not supported via AM
      dispatch(authActions.getJWTWhoami(null, { skipErrorPage: true }))
        .then(() => {
          dispatch(updateLastUsedDataCenter({ dcName: CURRENT_DC }));

          // needed for oTM users to fetch the currently logged in user data
          return dispatch(authActions.getWhoami());
        }).then(() => {
          const { user } = getState();
          const username = user.get('username');

          if (user.isAuthenticated()) {
            Sentry.setUser({ username });
          }

          return user.get('team_management') ?
            // whem oTM will be gone, can be used instead authActions.getWhoami()
            dispatch(authActions.getMeUserService()) :
            Promise.resolve();
        }).then(() => {
          const { user } = getState();
          authUtils.setLogoutUrl(user?.organization?.settings?.logout_url);
        })
        .finally(() => dispatch(actions.initialized()))
    ))
);

// Requests not critical for the initial UI load
export const postInitialize = () => (dispatch, getState) => {
  const { user } = getState();
  const username = user.get('username');

  dispatch(userConcurrencyActions.subscribeUser(username));
  dispatch(userConcurrencyActions.subscribeConcurrencies());
  dispatch(userTunnelsActions.subscribeUser(username));
  dispatch(userTunnelsActions.subscribeTunnels());

  // requests needed only for sauce-admin users
  dispatch(permissionsActions.getPermissions());
  dispatch(messagesActions.getMessages());
};

export const stop = () => (dispatch) => {
  dispatch(userConcurrencyActions.unsubscribeConcurrencies());
  dispatch(userTunnelsActions.unsubscribeTunnels());
  dispatch(actions.cleanup());
};
